export default __webpack_public_path__ + "static/media/air-quality-company.2172bb2e.svg";